export const tags = api => ({
  getAll(orgId, includeCounts = true, success, fail) {
    api.maybeAuthenticatedRequest('GET', `/organisations/${orgId}/tags?includeCounts=${includeCounts}`, null, success, fail);
  },
  create(orgId, value, success, fail) {
    api.maybeAuthenticatedRequest('POST', `/organisations/${orgId}/tags`, { value }, success, fail);
  },
  bulkCreate(orgId, values, success, fail) {
    api.maybeAuthenticatedRequest('POST', `/organisations/${orgId}/tags/bulk`, { values }, success, fail);
  },
  reset(orgId, values, success, fail) {
    api.maybeAuthenticatedRequest('POST', `/organisations/${orgId}/tags/reset`, { values }, success, fail);
  },
  search(orgId, value, success, fail) {
    api.maybeAuthenticatedRequest('GET', `/organisations/${orgId}/tags/search/${value}`, null, success, fail);
  },
  searchWithOptions(orgId, value, limit, exclude, success, fail) {
    api.maybeAuthenticatedRequest('GET', `/organisations/${orgId}/tags/search/${value}?limit=${limit}&${exclude.map(e => `exclude=${e}`).join('&')}`, null, success, fail);
  },
  get(orgId, id, success, fail) {
    api.authenticatedRequest('GET', `/organisations/${orgId}/tags/${id}`, null, success, fail);
  },
  update(orgId, id, data, success, fail) {
    api.authenticatedRequest('PUT', `/organisations/${orgId}/tags/${id}`, data, success, fail);
  },
  delete(orgId, id, success, fail) {
    api.authenticatedRequest('DELETE', `/organisations/${orgId}/tags/${id}`, null, success, fail);
  },
  full(orgId, tagIds, success, fail) {
    api.authenticatedRequest('GET', `/organisations/${orgId}/tags/full?${tagIds.map(t => `tagId=${t}`).join('&')}`, null, success, fail);
  },
  tagDocuments(orgId, tagType, tagIds, documents, success, fail) {
    api.maybeAuthenticatedRequest('POST', `/organisations/${orgId}/tags/${tagType}/tag`, { tags: tagIds, documents }, success, fail);
  },
  tagSingle(orgId, tagType, tagId, objectId, success, fail) {
    this.tagDocuments(orgId, tagType, [tagId], [objectId], updatedTags => success(updatedTags[0]), fail);
  },
  untagDocuments(orgId, tagType, tagIds, documents, success, fail) {
    api.maybeAuthenticatedRequest('DELETE', `/organisations/${orgId}/tags/${tagType}/tag`, { tags: tagIds, documents }, success, fail);
  },
  untagSingle(orgId, tagType, tagId, objectId, success, fail) {
    this.untagDocuments(orgId, tagType, [tagId], [objectId], updatedTags => success(updatedTags[0]), fail);
  },
  updateTaggedDocument(orgId, tagType, tagForId, tagId, data, success, fail) {
    api.authenticatedRequest('POST', `/organisations/${orgId}/tags/${tagType}/${tagForId}/${tagId}`, data, success, fail);
  },
});
